// utils/unitConversions.js (Example location)
export const UNIT_TO_GRAMS_SIMPLE = {
  // Metric Volume (Water Density Based)
  ml: 1,
  cl: 10,
  dl: 100,
  l: 1000,

  // Metric Mass
  g: 1,
  mg: 0.001,
  kg: 1000,

  // Common Volume Approx (Water Density Based)
  tsp: 5, // Approx 5ml -> 5g
  tbsp: 15, // Approx 15ml -> 15g

  // US Customary Volume (Water Density Based)
  "fl oz": 29.57, // US Fluid Ounce (~29.57ml -> ~29.57g)
  cup: 236.59, // US Cup (~236.59ml -> ~236.59g)
  pint: 473.18, // US Pint (2 cups -> ~473.18g)
  quart: 946.35, // US Quart (4 cups -> ~946.35g)
  gallon: 3785.41, // US Gallon (16 cups -> ~3785.41g)

  // Imperial/US Mass
  oz: 28.35, // Ounce (weight) (~28.35g)
  lb: 453.59, // Pound (~453.59g)

  // Add common 'piece' type units if needed, they won't convert automatically
  stk: undefined, // Example: 'piece' - grams must be entered manually if needed
  slice: undefined,
  pinch: undefined, // Often too variable, manual grams needed if required for calc
};

// Helper function to perform the calculation
export function calculateGrams(amount, unit) {
  const factor = UNIT_TO_GRAMS_SIMPLE[unit];
  const numericAmount = parseFloat(amount);

  if (factor !== undefined && !isNaN(numericAmount) && numericAmount >= 0) {
    // Round to avoid floating point issues, adjust precision as needed
    return Math.round(numericAmount * factor * 100) / 100;
  }
  // Return empty string or null if calculation isn't possible (e.g., 'stk', invalid amount)
  // Allows manual input to still work.
  return "";
}

export const UNIT_LIST = Object.keys(UNIT_TO_GRAMS_SIMPLE);
